import { Component } from '@angular/core';

@Component({
  selector: 'app-coordinator',
  templateUrl: './coordinator.component.html',
  styleUrl: './coordinator.component.scss',
  standalone: false,
})
export class CoordinatorComponent {
  activeTabValue = 'equipment-structure';
}
